var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"dynamic-data"},[_c('div',{staticClass:"little-box"},[_c('div',{staticClass:"little-box_title"},[_vm._v("今年用户访问量")]),_c('div',{staticClass:"updata",on:{"click":function($event){return _vm.handUpdata()}}},[_vm._v("刷新")])]),_c('div',{ref:"chartRef",staticClass:"dynamicData"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }